import { useSessionManager as useSessionManagerFromContext } from './sessionContext';

export const useSessionManager = () => {
  return useSessionManagerFromContext();
};
